import React from 'react';
import { CustomLink } from '../link/link.comp';
import { StyledDiv } from './breadcrumbs.styles';

interface IBreadcrumb {
	name: string;
	url: string;
}

export const Breadcrumbs = ({
	breadcrumbs,
}: {
	breadcrumbs: IBreadcrumb[];
}) => (
	<StyledDiv>
		{breadcrumbs.map((b, idx) => {
			return (
				<React.Fragment key={`breadcrumb_${idx}`}>
					{idx !== 0 && <p className="divider">/</p>}
					<CustomLink className="link" variant="secondary" href={b.url}>
						{(b.name || '').replace(/\&#x2011;/g, '- ')}
					</CustomLink>
				</React.Fragment>
			);
		})}
	</StyledDiv>
);
